import protoRoot from "../proto-root";

const name = "startListeningRPCRequest";

function create() {
  const StartListeningRPCRequest = protoRoot.lookupType(
    "comm.StartListeningRPCRequest"
  );

  const request = StartListeningRPCRequest.create();
  return { payload: request, name };
}

export default {
  create,
  name
};
